import { useSearchParams } from 'next/navigation'
import { useState } from 'react'

import { useGetShopsQuery } from '@/screens/shops/api/shops-api'

import { ShopsMapPointType } from '@/widgets/ShopsMapNew/ui/ShopsMap/consts'

import { Pvz } from '@/features/shops/pvz-map'

import { useRegion } from '@/entities/regions'

import { Chip } from '@/shared/ui'

import { ShopsMapBlock } from './shops-map-block/shops-map-block'
import { ShopsTopPanel } from './ShopsTopPanel/ShopsTopPanel'

import cls from './shops.module.scss'

enum ShopsTabEnum {
	Shops = 'shops',
	Pvz = 'pvz',
	Services = 'services'
}

const shopsTabToShopsMapPoint = {
	[ShopsTabEnum.Shops]: ShopsMapPointType.Shops,
	[ShopsTabEnum.Services]: ShopsMapPointType.Services
}

const extractShowQueryParam = (show: string | null): ShopsTabEnum => {
	return typeof show === 'string' &&
		(ShopsTabEnum.Shops === show || ShopsTabEnum.Pvz === show || ShopsTabEnum.Services === show)
		? show
		: ShopsTabEnum.Shops
}

export const ShopsScreen = () => {
	const searchParams = useSearchParams()
	const [type, setType] = useState<ShopsTabEnum>(extractShowQueryParam(searchParams.get('show')))
	const { data } = useGetShopsQuery(null)

	const { currentRegion } = useRegion()
	const showServices = data?.some(shop => currentRegion.REGION_NAME === shop.REGION && shop.UF_IS_SERVICE === '1')
	return (
		<div>
			<div className={cls.topPanelWrap}>
				<ShopsTopPanel />
			</div>

			<div className={cls.tabsContainer}>
				<Chip
					theme="outlined"
					label="Магазины"
					isSelected={type === ShopsTabEnum.Shops}
					onClick={() => setType(ShopsTabEnum.Shops)}
				/>
				{showServices && (
					<Chip
						theme="outlined"
						label="Сервисные центры"
						isSelected={type === ShopsTabEnum.Services}
						onClick={() => setType(ShopsTabEnum.Services)}
					/>
				)}

				<Chip
					theme="outlined"
					label="Пункты выдачи"
					isSelected={type === ShopsTabEnum.Pvz}
					onClick={() => setType(ShopsTabEnum.Pvz)}
				/>
			</div>

			{type === ShopsTabEnum.Pvz && <Pvz />}

			{(type === ShopsTabEnum.Shops || type === ShopsTabEnum.Services) && (
				<ShopsMapBlock pointType={shopsTabToShopsMapPoint[type]} />
			)}
		</div>
	)
}
